export const FETCH_EMPLOYMENT_REQUEST = 'FETCH_EMPLOYMENT_REQUEST';
export const FETCH_EMPLOYMENT_SUCCESS = 'FETCH_EMPLOYMENT_SUCCESS';
export const FETCH_EMPLOYMENT_FAILURE = 'FETCH_EMPLOYMENT_FAILURE';

export const CREATE_EMPLOYMENT_REQUEST = 'CREATE_EMPLOYMENT_REQUEST';
export const CREATE_EMPLOYMENT_SUCCESS = 'CREATE_EMPLOYMENT_SUCCESS';
export const CREATE_EMPLOYMENT_FAIL = 'CREATE_EMPLOYMENT_FAIL';
export const CREATE_EMPLOYMENT_RESET = 'CREATE_EMPLOYMENT_RESET';

export const DELETE_EMPLOYMENT_REQUEST = 'DELETE_EMPLOYMENT_REQUEST';
export const DELETE_EMPLOYMENT_SUCCESS = 'DELETE_EMPLOYMENT_SUCCESS';
export const DELETE_EMPLOYMENT_FAIL = 'DELETE_EMPLOYMENT_FAIL';
export const DELETE_EMPLOYMENT_RESET = 'DELETE_EMPLOYMENT_RESET';

export const UPDATE_EMPLOYMENT_REQUEST = 'UPDATE_EMPLOYMENT_REQUEST';
export const UPDATE_EMPLOYMENT_SUCCESS = 'UPDATE_EMPLOYMENT_SUCCESS';
export const UPDATE_EMPLOYMENT_FAIL = 'UPDATE_EMPLOYMENT_FAIL';
export const UPDATE_EMPLOYMENT_RESET = 'UPDATE_EMPLOYMENT_RESET';

